/**
 * Created by admin on 15.08.2018.
 */

$( window ).load(function() {

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    let customerData = $('#customer-data');

    const customerName = customerData.attr('data-customer-name');
    const customerEmail = customerData.attr('data-customer-email');

    window.token = 'token:AQICAHjKy8UuGGrqveB8Wwbl1QTvC8bw3IK3F+SCpeWE4NP3vAEVfzMW6jt2CXk8xN+FpjU4AAAA1jCB0wYJKoZIhvcNAQcGoIHFMIHCAgEAMIG8BgkqhkiG9w0BBwEwHgYJYIZIAWUDBAEuMBEEDH8s6s7DF9Nw6y+g5wIBEICBjlREuB+Rt5W799TBqQhZX4WF0RqfpmuzVcHuwLRVftb8gqsLMhD6VtjRSr+cqL+9P91p2ZvRAflX6k3Bx17BPMuUJgK/5vTu00z6eJJdN+FkObqpqWqlhn3hh/W7iHsYWjtJmcQ9M9LxpuNK7TzXIOpc1dzv/kcZ+it01dB+aCpRHqIWNiQUFn/zzJHcWJ0=';

    let answers = {
        customerName,
        customerEmail,
        '1':'',
        '2':'',
        '3-1':'',
        '3-2':'',
        '3-3':'',
        '4':'',
        '5':'',
        '6':undefined,
        '7':undefined,
    };

    $('.select-cube' ).click(function (  ) {

        let question = this.getAttribute('question');
        let value = this.getAttribute('value');
        console.log( question );
        answers[question] = value;



        if( question === '3-1' || question === '3-2' ){
            $('input[question="3-3"]').val('');
            answers['3-3'] = '';
        } else {
            $('input[question="'+question+'"]').val('');
        }
        $('.select-cube[question="'+question+'"]').css({background:'#fff', color:'#000'});
        $(this).css({background:'#000', color:'#fff'});

        console.log( answers )
        checkAnswers (  )

    });

    $('input[question]').on('input',function (  ) {
        let question = this.getAttribute('question');

        $('.not-sure-button[question="'+question+'"]')
        if( question == '7' || question =='6'){
            $('.not-sure-button[question="'+question+'"]').css({color:'#000', background:'#fff'})
        }
        if( question === '3-3' ){
            answers['3-3'] =   this.value;
            $('.select-cube[question="3-2"] ,  .select-cube[question="3-1"]'  ).css({background:'#fff', color:'#000'});
            answers['3-1'] = '';
            answers['3-2'] =  ''
        } else {
            answers[question] = this.value;
            $('.select-cube[question="'+question+'"]').css({background:'#fff', color:'#000'});

        }
        checkAnswers (  );
    });


    function checkAnswers (  ) {
        if( $("#customer-email-address").val() === '' || validateEmail($("#customer-email-address").val()) === false ) {
            return false;
        }

        doubledAnswers = {
            '3-1':answers['3-1'],
            '3-2':answers['3-2'],
            '3-3':answers['3-3'],
        };

        singleAnswers = {
            '1':answers['1'],
            '2':answers['2'],
            '4':answers['4'],
            '5':answers['5'],
        };
        for(var a in singleAnswers ){
            if( singleAnswers[a] ==='' ){
                return false;
            }
        }



        if( answers['6']===undefined||answers['7'] === undefined ){
            return false
        }

        if( doubledAnswers['3-3'] === ''  ){
            if( doubledAnswers['3-1'] =='' || doubledAnswers['3-2'] == ''){
                return false
            }  else {

                $('.apply_answers__button').addClass('can-hover');
                $('.add_to_cart_button' ).html('Add to cart' );
                $('.custom-list-links').css({background:'#fff'})
                return true;
            }
        }

    }

    $('.apply_answers__button').click( function (  ) {
        putData();
        if( checkAnswers()){
            closeMe( 'full' );
            //putData()

        } else {
            closeMe('empty')
        }

        function closeMe ( full ) {
            if( full ==='full' ){
                $('.create-size').html( 'Sizing data received!' ).css({background:'#000', color:'#fff'});
                $('.add_to_cart_button').html( 'Add to cart' )

                $('#add_to_cart_button' ).attr('canadd','true');
                $('#add_to_cart_button' ).html('Add to cart')
                $('.create-size-popup' ).css({display:'none'});
                $('.opacied_block--for-size' ).removeClass('shown');

                $('.start-block-opacied').css({
                    background: 'none',
                    'z-index':-10
                });
                $('#customize-jacket__from-jacket-previe').css({
                    'z-index':'999'
                });
            };

            //$('.create-size-popup' ).css({display:'none'})
        };

        function putData (  ) {



            let bandSize = answers['2-1'];
            let cupSize = answers['2-2'];
            if( answers['2-3'] !== undefined &&  answers['2-3'] !== ''  ){

            }

            let height = answers['4'].split('');


            let heightInCm = ( height[0]* 30.48 )+ ( height[2]* 2.54 );


            let mesurement = {
                bandSize:bandSize,
                cupSize:cupSize,
                mbHeight:heightInCm,
                mbWeight:Number( answers['5'])*0.453592,
            };

            if( answers['6'] !== undefined && answers['6']!=='' ){
                mesurement.mbhip = answers['6'];
            };


            if( answers['7'] !== undefined && answers['7']!=='' ){
                mesurement.mbwaist = answers['7'];
            };

            window.data  = {
                "gender": "female",
                "measurements":mesurement,
            };

            var sizes = {
                waist_shape:answers['1'],
                hip_shape:answers['2'],
                bra_size_1:answers['3-1'],
                bra_size_2:answers['3-2'],
                bra_size_3:answers['3-3'],
                tall:answers['4'],
                weigh:answers['5'],
                hip_circumference:answers['6'],
                waist_circumference:answers['7'],
                email :$("#customer-email-address").val(),
            };
             $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: '//choiss.herokuapp.com/api/sizes/add',
                    data: sizes,
                    // crossDomain : true,
                 success:function  ( response ) {
                        console.log( response )
                 }
             })



            // $.ajax({
            //     type: "POST",
            //     url: 'https://api.bespokify.com/v2/predict/body',
            //     data: data,
            //     crossDomain : true,
            //     headers: {
            //         'Authorization':token,
            //         "Content-Type":"application/json",
            //         'Access-Control-Allow-Origin': '*',
            //
            //     },
            //     success: function ( success ) {
            //
            //         console.log( success );
            //         $('.start-block-opacied').css({
            //             background: 'none',
            //             'z-index':-10
            //         });
            //         $('#customize-jacket__from-jacket-previe').css({
            //             'z-index':'999'
            //         });
            //
            //     },
            //     error:function ( error ) {
            //         console.log('000000', error )
            //     },
            //     dataType: "json",
            // });

        }

    });

    $('.close-create-size-button .icon').click(function (  ) {
        $('.create-size-popup' ).css({display:'none'});
        $('.opacied_block--for-size' ).removeClass('shown');
        $('.custom-list-links').css({background:'#fff'})
        $('.start-block-opacied').css({
            background: 'none',
            'z-index':-10
        });

        $('#customize-jacket__from-jacket-previe').css({
            'z-index':'99'
        });
    });

    $('.not-sure-button').click( function (  ) {
        var question = this.getAttribute( 'question' );
        answers[question] = '';
        $('input[question="'+question+'"]').val('');
        $(this).css({color:'#fff', background:'#000'});
        checkAnswers (  );
    })

});